import * as Yup from 'yup';
import { Certification } from '@models';

export function useValidationSchema() {
  return Yup.object<Certification>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
  }) as Yup.Schema<Certification>;
}
